import { Directive, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { PwaModeService } from '../services/pwa-mode.service';

@Directive({ selector: '[appBrowserOnly]' })
export class BrowserOnlyDirective implements OnInit {
  constructor(private template: TemplateRef<Object>, private container: ViewContainerRef, private mode: PwaModeService) {}

  ngOnInit(): void {
    if (!this.mode.isEnabled) { this.container.createEmbeddedView(this.template); }
  }
}

@Directive({ selector: '[appPwaOnly]' })
export class PwaOnlyDirective implements OnInit {
  constructor(private template: TemplateRef<Object>, private container: ViewContainerRef, private mode: PwaModeService) {}

  ngOnInit(): void {
    if (this.mode.isEnabled) { this.container.createEmbeddedView(this.template); }
  }
}

@Directive({ selector: '[appPwaMode]', exportAs: 'pwaMode' })
export class PwaModeDirective {
  constructor(private mode: PwaModeService) {}

  get isEnabled(): boolean { return this.mode.isEnabled; }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/navbar/browser-only.directive.ts